import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { removeNotification } from '../store/slices/notificationSlice';

const NotificationContainer: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const notifications = useSelector((state: RootState) => state.notifications.data);

    return (
        <div className="notification-container">
            {notifications.map((n) => (
                <div
                    key={n.id}
                    className={`notification-item${n.autoDismiss === false ? ' notification-persistent' : ''} ${
                        n.type === "success"
                            ? "notification-success"
                            : n.type === "error"
                                ? "notification-error"
                                : "notification-info"
                    }`}
                    role="status"
                    aria-live="polite"
                >
                    <span>{n.message}</span>
                    <button
                        className="notification-close"
                        onClick={() => dispatch(removeNotification(n))}
                        aria-label="Close notification"
                    >
                        &times;
                    </button>
                </div>
            ))}
        </div>
    );
};

export default NotificationContainer;
